import React from "react";
import InputWrapper from "../Inputs/InputWrapper";
import FloatingLabelInput from "../Inputs/FloatingLabelInput";
import { Controller, useFormContext } from "react-hook-form";
import { signUpFormValidators } from "../../../helpers/signUpFormConstants";
import { detectAutofill } from "../signUpHelpers";

const LastNameInput = () => {
  const { control } = useFormContext();
  const INPUT_NAME = "lastName";

  const onChangeHandler =
    (formOnChange: (...event: any[]) => void) =>
    (e: React.ChangeEvent<HTMLInputElement>) => {
      detectAutofill(e.currentTarget);
      formOnChange(e.currentTarget.value);
    };

  return (
    <Controller
      name={INPUT_NAME}
      rules={signUpFormValidators.required}
      control={control}
      render={({
        field: { onChange, ...field },
        fieldState: { invalid, isTouched, isDirty },
      }) => (
        <InputWrapper
          errorMsg="This field is required."
          hasError={invalid && isTouched}
          label="Last name"
          valid={!invalid && isDirty}
          valueExists={!!field.value}
          name={INPUT_NAME}
        >
          <FloatingLabelInput
            hasError={invalid && isTouched}
            autoComplete="family-Name"
            onChange={onChangeHandler(onChange)}
            {...field}
          />
        </InputWrapper>
      )}
    />
  );
};

export default LastNameInput;
